// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".homepage-key-statistics-overview__wrapper[data-v-25ab5550]{max-width:1328px;margin:64px auto 0}@media (max-width:767px){.homepage-key-statistics-overview__wrapper[data-v-25ab5550]{margin:32px auto 0}}", ""]);
// Exports
module.exports = exports;
